import React, { useState, useEffect, Fragment } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputTextAlpha from "../../helpers/InputTextAlpha";


function InvoiceGenerate(props)
{

    
    const [view, setView] = useState('btn');

 
    const [row, setRow] = useState( null);

    
    const [filterParam, setFilterParam] = useState({

        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''), 
        r_imie_nazwisko: props.mainView.readFilter('r_imie_nazwisko',''), 
   
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),              
       
    });


    const [isStarted, setIsStarted] = useState(0);





    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

       setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
       
       var modX = val.length % 3;
       if(  val.length == 0 || modX == 0 || msg =='combo')
        setRow(null);

       props.mainView.writeFilter(filedName, val);
   }


   const goNextNew = () => {
       console.log("goNext");    
       setRow(null);    
   }




    const getToApprove = () => {


 
        props.mainView.setProgress(-2);

    


        fetch( Config.master + '/rest_v1_calc,get_to_generate', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setRow(res.result);
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }


    const goCreateById = (idUmowy) => {

  
 
        props.mainView.setProgress(-2);

        var req =  {
            id: idUmowy
        }


        fetch( Config.master + '/rest_v1_calc,gen_invoice', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {

                        if(res.status == 'ERROR_MSG') 
                        {
                            var callBackId = parseInt(res.result);

                            for(var k=0;k<row.length; k++)
                                {
                                    if(row[k].status == 1 && row[k].id == callBackId) //na gotowe..
                                    {                                        
                                        row[k].status = 3; //blad                                        
                                        break;
                                    }
                                }                        
                                setRow( JSON.parse( JSON.stringify(row) ) );
                                goCreate();

                                props.mainView.showDialog( "Błąd",  "Wystąpił nieznany problem. Zgłoszenie zostało już wysłane do wsparcia systemu." , "ok" , null);  
                        }else
                        if(res.status == 'OK') //wystawiono prawidlowo.. mozna wystawiac kolejny..
                        {
                            var callBackId = parseInt(res.result);

                            for(var k=0;k<row.length; k++)
                                {
                                    if(row[k].status == 1 && row[k].id == callBackId) //na gotowe..
                                    {                                        
                                        row[k].status = 2; //gotowe
                                        if(props.onSuccess != undefined) props.onSuccess();
                                        break;
                                    }
                                }                        
                                setRow( JSON.parse( JSON.stringify(row) ) );
                                goCreate();
                        }else
                        {
                            props.mainView.showDialog( "Błąd",  'Spróbuj ponownie za chwilę.' , "ok" , null);    
                        }
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }


    


    const goCreate = () => {



        //znajdz kolejne ID oczekujace na wystawienie...
        var findId = -1;

        for(var k=0;k<row.length; k++)
        {
            if(row[k].status == 0) //oczekuje..
            {
                findId = row[k].id; 
                row[k].status = 1; //ustaw czekaj...
                break;
            }
        }

        setRow( JSON.parse( JSON.stringify(row) ) );

        if(findId > -1)
        {
            goCreateById(findId);
        }

    }

    const startX = () => {

        if(isStarted == 1) return;

        setIsStarted(1);
        goCreate();
    }
    

 

    const showDlg = () => {
         getToApprove();
         setView("dlg");   
    }     

    const closeDlg = () => {
        setView("btn");  
        setIsStarted(0); 
   }  
 
    var itemsTN = [
        { v: '0', title: 'Nie - rodzice nie mogą płacić szybkim przelewem' }, 
        { v: '1', title: 'Tak - rodzice mogą płacić szybkim przelewem' }, 
    ];



    if(row == null)
    {
        setRow([]);
        getToApprove();
        return <span>...</span>
    }


    var progress = null;
    var gotowych = 0;

    for(var k=0;k<row.length; k++)
        {
            if(row[k].status == 2) //oczekuje..
            {
                gotowych++;
            }
        }

    var proc =  parseInt( (100 * gotowych) / row.length);
    
    if(gotowych > 0) 
    {
        progress = <div><strong>Postęp {proc} % </strong></div>;
    }



    var dlg_view =  (

            <div className="dlg_window dlg_type_xx shadowx">

                    <div className="dlg_title">
                        Generator rachunków
                    </div>


                    <div className="dlg_content_x">


                                    <div className="tip">
                                        Po wybraniu 'wystaw dokumenty', eLizak znajdzie wszystkie aktywne umowy i utworzy na ich podstawie gotowe rachunki do zapłaty. 
                                    </div>

                                  
                                    <div className="table_filter">


                                           <div className="filter_controll">   
                                             <label>Grupa: </label>                             
                                             <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                                           </div> 



                                           <div className="filter_controll">   
                                                        <label>Dziecko: </label>                             
                                                        <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                                            </div>  
                        

                                     


                                    </div>


                                    <br/>

                                    <div className="form_tab">

                                    <div>
                                        Dokumenty (okresy rozliczeniowe) oczekujące na wystawienie: {row.length} 
                                    </div>

                                    {progress}
 
                                    <div className="bg_center scroll150 nostick">                                            

                                            <table className="table" >
                                                    <thead>
                                                    <tr className="header">                                                                                  
                                                        <td>LP</td>                                                                                                                                
                                                        <td>Numer umowy</td>                                                                                                                                                                                           
                                                        <td>Dziecko</td>                                                                                                                                                                                           
                                                        <td>Okres do wyst.</td>                                                                                                                                                                                           
                                                        <td>Status</td>                                                                                                                                                                                           
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        row.map( (item, ix) => {

                                                            var st = item.status;
                                                            if(item.status == 0) st = "---";
                                                            if(item.status == 1) st = "Czekaj...";
                                                            if(item.status == 2) st = "Gotowe!";
                                                            if(item.status == 3) st = "Błąd!";

                                                            return <tr>
                                                                <td className="gocenter">{ix+1}</td>                                                                                                                                
                                                                <td className="goleft">{item.numer_umowy}</td>                                                                                                                                                                                           
                                                                <td className="goleft">{item.nazwisko + " " + item.imie}</td>                                                                                                                                                                                           
                                                                <td className="goleft">
                                                                    {item.okres_do_wystawienia }
                                                                    {
                                                                        item.roz_na_koniec_m == 1 &&
                                                                        <sup>&nbsp; gen. na koniec miesiąca</sup>
                                                                    }
                                                                    {
                                                                        item.roz_na_koniec_m == 0 &&
                                                                        <sup>&nbsp; gen. na początku miesiąca</sup>
                                                                    }
                                                                </td>   
                                                                <td className="gocenter" >{st}</td>  
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
  

                                        <div className="form_split"></div>
                                        <br/>
                                        <div className="form_split"></div>

                                        <div className="form_control">      
                                            {
                                                row.length > 0 && isStarted == 0 &&
                                                <Fragment>
                                                    <div className="btn" onClick={startX}>wystaw dokumenty</div>                                                  
                                                </Fragment>                                                
                                            }                                                                                  
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={closeDlg}>zamknij</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;

    

    return  <React.Fragment>
                <div className="btn"    onClick={showDlg} >Utwórz wg. umów</div> 
                {dlg_view} 
           </React.Fragment>
}


export default InvoiceGenerate;